//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'landingPageFooterXhs',
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/LivePageFooter.vue